/*
 * @Author: Junchi Zhao
 * @LastEditors: Please set LastEditors
 * @Description:
 */
import config from '../config';
function deleteChildren(list) {
  for (const iterator of list) {
    if (iterator.children) {
      if (iterator.children.length > 0) {
        this.deleteChildren(iterator.children);
      } else {
        delete iterator.children;
      }
    }
  }
  return list;
}
/*
 * 二进制显示验证种类  0000
 * 0001 => 1数字 0010 => 2特殊符号 0100 => 4小写字母 1000 => 8大写字母
 * NORMAL简单密码： 任意字符并且长度在8-16位
 * MIDDLE中等密码： 至少包含数字、符号及大小写字母中的两种并且长度在8-16位
 * COMPLEX复杂密码： 包含数字、符号及字母大小写并且长度在8-16位
 */
const PWD_LEVEL = {
  COMPLEX: 4,
  MIDDLE: 2,
  NORMAL: 0
};
/**
 * @description: 10进制转2进制并补0
 * @param {*} num 10进制数字
 * @param {*} digit 补零位数
 * @return {*}
 * @author: Junchi Zhao
 */
function number10To2(num, digit) {
  //10进制转2进制并补0至4位
  let str = parseInt(num).toString(2);
  if (str.length < digit) {
    str = '0'.repeat(digit - str.length) + str;
  }
  return str;
}
/**
 * @description: 密码输入建议
 * @param {*} score
 * @return {*}
 * @author: Junchi Zhao
 */
function suggestions(score) {
  const TYPES = {
    0: '大写字母',
    1: '小写字母',
    2: '符号',
    3: '数字'
  };
  //简单密码不需要校验
  if (PWD_LEVEL[config.pwdLevel] === 0) {
    return '';
  } else if (PWD_LEVEL[config.pwdLevel] === 2) {
    //10进制转2进制并补0至4位
    const str = number10To2(score, 4);
    const result = [];
    for (let i = 0; i < str.split('').length; i++) {
      if (str.split('')[i] === '0') {
        result.push(TYPES[i]);
      }
    }
    return '还须包含' + result.reverse().join('或');
  } else if (PWD_LEVEL[config.pwdLevel] === 4) {
    //10进制转2进制并补0至4位
    const str = number10To2(score, 4);
    const result = [];
    for (let i = 0; i < str.split('').length; i++) {
      if (str.split('')[i] === '0') {
        result.push(TYPES[i]);
      }
    }
    return '还须包含' + result.reverse().join('、');
  }
}
/**
 * @description: 密码校验
 * @param {*} pwd
 * @return {*}
 * @author: Junchi Zhao
 */
function validPwd(pwd) {
  let score = 0;
  if (pwd && pwd.length < 8) {
    return {
      result: false,
      level: config.pwdLevel,
      desc: '密码长度不能小于8位'
    };
  }
  if (pwd && pwd.length > 16) {
    return {
      result: false,
      level: config.pwdLevel,
      desc: '密码长度不能大于16位'
    };
  }
  //数字
  const numberReg = /\d/;
  //特殊符号
  // eslint-disable-next-line no-useless-escape
  const specialReg = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/;
  //小写字母
  const lowerReg = /[a-z]/;
  //大写字母
  const upperReg = /[A-Z]/;
  if (numberReg.test(pwd)) {
    score += 1;
  }
  if (specialReg.test(pwd)) {
    score += 2;
  }
  if (lowerReg.test(pwd)) {
    score += 4;
  }
  if (upperReg.test(pwd)) {
    score += 8;
  }
  //10进制转2进制并补0至4位
  const result = number10To2(score, 4);
  if (PWD_LEVEL[config.pwdLevel] <= result.split('').reduce((a, b) => Number(a) + Number(b), 0)) {
    return {
      result: true,
      level: config.pwdLevel,
      desc: '密码强度符合要求'
    };
  } else {
    return {
      result: false,
      level: config.pwdLevel,
      desc: suggestions(score)
    };
  }
}
export default {
  install(Vue, options) {
    Vue.prototype.deleteChildren = deleteChildren;
    Vue.prototype.$validPwd = validPwd;
  }
};
